import Knowledge from "@/pages/Knowledge";
export default Knowledge;
